module.exports = __webpack_public_path__ + "c304d6647980f4eb3ddba58bf47e132c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-parvulo-pass.png
// module id = 110
// module chunks = 0